// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WulZ","left":"styles_left__37apy"};